import messages from '../validations/messages';
import validations, {
  type ValidatableModel,
  type ValidatableValue,
} from '../validations/validations';

export const getRequiredError = (
  model: ValidatableModel,
  value: ValidatableValue,
  required: boolean | undefined,
): string | undefined => {
  if (required) {
    if (!validations.required(model, value)) {
      return messages.required;
    }
  }
  return undefined;
};
